import { useGetQuery } from './useGetQuery'

export const useSprints = () => {
  const { data, isLoading: isSprintsLoading, isError: isSprintsError } = useGetQuery('/aws/sprints', 'sprints')

  const sprints = data ?? []

  return { sprints, isSprintsLoading, isSprintsError }
}
